import { motion } from "framer-motion";
import { Search, Compass, Rocket, Activity, TrendingUp } from "lucide-react";

const STEPS = [
  {
    n: "01",
    title: "Discover",
    icon: Search,
    body:
      "Audit your funnel, creative, data and tech. We map what’s leaking and what’s ready to scale.",
  },
  {
    n: "02",
    title: "Strategize",
    icon: Compass,
    body:
      "Channel mix, offer architecture, creative bets and a 90-day roadmap aligned to a single north-star metric.",
  },
  {
    n: "03",
    title: "Execute",
    icon: Rocket,
    body:
      "Ship campaigns, storefronts, creative and tracking in weeks — not quarters. Daily standups, weekly releases.",
  },
  {
    n: "04",
    title: "Optimize",
    icon: Activity,
    body:
      "Test hypotheses, kill losers fast, double-down on winners. CRO and CAC are reviewed every single week.",
  },
  {
    n: "05",
    title: "Scale",
    icon: TrendingUp,
    body:
      "New geos, new SKUs, new channels. Once unit economics work, we pour fuel — responsibly.",
  },
];

export default function Process() {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="relative py-24 sm:py-32 bg-zinc-950"
    >
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-yellow-400/30 to-transparent" />
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-3xl mb-16">
          <p className="text-yellow-400 font-mono-ui text-xs tracking-[0.22em] uppercase mb-4">
            · How we work
          </p>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tighter">
            A five-step lab.
            <br />
            <span className="text-zinc-500">No fluff, no five-month decks.</span>
          </h2>
        </div>

        <div className="relative">
          <div className="hidden lg:block absolute top-12 left-0 right-0 h-px border-t border-dashed border-white/15" />
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8 lg:gap-6 relative">
            {STEPS.map((s, idx) => {
              const Icon = s.icon;
              return (
                <motion.div
                  key={s.n}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-40px" }}
                  transition={{ duration: 0.45, delay: idx * 0.08 }}
                  className="group"
                  data-testid={`process-step-${s.n}`}
                >
                  <div className="relative h-10 w-10 rounded-full border border-white/15 bg-zinc-950 flex items-center justify-center text-yellow-400 group-hover:border-yellow-400 group-hover:bg-yellow-400/10 transition-all">
                    <Icon size={18} />
                  </div>
                  <div className="mt-5 font-mono-ui text-xs text-zinc-500 tracking-[0.22em]">
                    STEP {s.n}
                  </div>
                  <h3 className="mt-2 font-display text-2xl font-semibold tracking-tight text-zinc-50">
                    {s.title}
                  </h3>
                  <p className="mt-3 text-zinc-400 text-sm sm:text-base leading-relaxed">
                    {s.body}
                  </p>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
